'use client';

import React, { useState } from 'react';
import OverallProgress from './OverallProgress';
import ModuleGrid from './ModuleGrid';

const TOPICS = ['All', 'Strategy Fundamentals', 'Risk Management', 'Chart Patterns'] as const;
type Topic = (typeof TOPICS)[number];

export default function LearningDashboard() {
  const [activeTopic, setActiveTopic] = useState<Topic>('All');

  return (
    <div className="space-y-6">
      {/* Overall progress bar */}
      <OverallProgress />

      {/* Topic filter tabs */}
      <div className="flex items-center gap-2 flex-wrap">
        {TOPICS.map((topic) => (
          <button
            key={topic}
            onClick={() => setActiveTopic(topic)}
            className={`px-3.5 py-1.5 rounded-lg text-xs font-semibold transition-all duration-150 ${
              activeTopic === topic
                ? 'bg-primary text-primary-foreground'
                : 'bg-card border border-border text-muted-foreground hover:text-foreground hover:border-primary/40'
            }`}
          >
            {topic}
          </button>
        ))}
      </div>

      {/* Module grid */}
      <ModuleGrid activeTopic={activeTopic} />
    </div>
  );
}
